import React from 'react';
import { createRoot } from 'react-dom/client';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import App from './App';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#00D9FF',
      light: '#33E5FF',
      dark: '#00A8CC',
    },
    secondary: {
      main: '#667EEA',
      light: '#8B9FFF',
      dark: '#5568D3',
    },
    background: {
      default: '#0F1419',
      paper: '#1A1F2E',
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#B8C1D4',
    },
    error: {
      main: '#FF6B6B',
    },
    warning: {
      main: '#FFB84D',
    },
    success: {
      main: '#51CF66',
    },
    divider: '#2D3748',
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    h4: {
      fontSize: '2rem',
      fontWeight: 600,
      letterSpacing: '-0.5px',
    },
    h6: {
      fontSize: '1.125rem',
      fontWeight: 600,
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.6,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundImage: 'linear-gradient(135deg, #0F1419 0%, #1A1F2E 100%)',
          backgroundAttachment: 'fixed',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: '#1A1F2E',
          borderRadius: '12px',
          border: '1px solid rgba(0, 217, 255, 0.1)',
          backdropFilter: 'blur(10px)',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          '&:hover': {
            borderColor: 'rgba(0, 217, 255, 0.3)',
            boxShadow: '0 8px 32px rgba(0, 217, 255, 0.1)',
            transform: 'translateY(-2px)',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          borderColor: '#2D3748',
          color: '#B8C1D4',
          '&.Mui-selected': {
            backgroundColor: '#00D9FF',
            color: '#0F1419',
            borderColor: '#00D9FF',
            fontWeight: 600,
            '&:hover': {
              backgroundColor: '#00A8CC',
              borderColor: '#00A8CC',
            },
          },
          '&:hover': {
            backgroundColor: 'rgba(0, 217, 255, 0.1)',
          },
          transition: 'all 0.2s ease',
        },
      },
    },
  },
});

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
